export default {
  common: {
    yes: 'Có',
    no: 'Không',
    currency: { php: 'PHP', vnd: 'VND', cny: 'CNY', all: 'Tất cả tiền tệ' },
    status: {
      sufficient: 'Đủ {pct}%',
      warning: 'Cảnh báo {pct}%',
      exhausted: 'Đã hết',
      unallocated: 'Chưa phân bổ',
    },
    change: { add: '+ Tăng', sub: '- Giảm', consume: 'Tiêu thụ điều chỉnh' },
    remaining: 'Còn lại',
    totalAmount: 'Tổng hạn mức',
    usedAmount: 'Đã dùng',
    noPermission: '- Không có quyền -',
    self: '(Chính mình)',
    exportExcel: 'Xuất Excel',
  },
  sys: {
    column: {
      title: 'Hạn mức HV',
      subtitle: 'Khả dụng / Tổng',
      subtitleNew: 'Vận hành · Điều chỉnh hội viên',
      tagRefactor: 'refactor',
    },
    btn: { manage: 'Quản lý hạn mức', manageNew: 'Mới' },
    section: {
      userTitle: 'Hạn mức điều chỉnh hội viên',
      userSubtitle: 'Vận hành · Điều chỉnh hội viên',
      agentTitle: 'Hạn mức phân bổ đại lý',
      agentSubtitle: 'Marketing · Phân bổ cho đại lý',
    },
    manage: {
      title: 'Quản lý hạn mức tài khoản',
      totalUsed: 'Tổng đã dùng: ',
      remainingLabel: 'Còn lại',
      monthlyConsumed: 'Tháng này',
      monthlyUser: 'Hội viên',
      monthlyAgent: 'Đại lý',
      viewAllPrefix: 'Xem tất cả bản ghi thay đổi',
      viewAllLink: 'Bản ghi thay đổi hạn mức',
      recentChanges: 'Thay đổi gần đây',
      recentChangesSub: '5 mục gần nhất',
      viewAll: 'Xem chi tiết đầy đủ →',
      memberLabel: 'Thành viên',
      typeAdd: '+ Tăng',
      typeSub: '- Giảm',
      typeConsume: 'Tiêu thụ điều chỉnh',
      col: {
        time: 'Thời gian',
        type: 'Loại',
        currency: 'Tiền tệ',
        change: 'Thay đổi',
        afterRemain: 'Sau',
        operatorRemark: 'Người thao tác / Ghi chú',
      },
    },
    adjust: {
      title: 'Điều chỉnh hạn mức',
      opType: 'Loại thao tác',
      add: '+ Tăng',
      sub: '- Giảm',
      amount: 'Số tiền ({currency})',
      reason: 'Lý do',
      reasonPlaceholder: 'Vui lòng nhập lý do thay đổi hạn mức (để kiểm toán)',
      reasonMaxLen: 'Tối đa 100 ký tự',
      amountRequired: 'Vui lòng nhập số tiền',
      amountMin: 'Số tiền phải lớn hơn 0',
      reasonRequired: 'Vui lòng nhập lý do',
      preview: {
        after: '→ Sau khi điều chỉnh: Còn {remain} / Tổng {total}',
        error: '⚠ Không thể giảm số tiền này; vượt quá hạn mức khả dụng còn lại ({remain})',
      },
      myAvailable: 'Hạn mức khả dụng của tôi ({currency})',
      myQuotaEmpty: '⚠ Bạn hiện không còn hạn mức điều chỉnh đại lý. Vui lòng nhờ quản trị cấp cao bổ sung trước khi tăng.',
      exceedMyQuota: '⚠ Vượt quá hạn mức khả dụng của bạn ({myAvailable}); không thể tăng nhiều như vậy.',
      singleLimit: {
        exceeded: 'Giới hạn {dir} mỗi lần là {cur} {max}; lần này {cur} {amount} đã vượt quá',
        add: 'tăng hạn mức',
        reduce: 'giảm hạn mức',
      },
      success: 'Thành công',
      fail: 'Thất bại',
    },
  },
  financial: {
    title: 'Nhật ký thay đổi hạn mức',
    desc: 'Trang này ghi lại tất cả thay đổi hạn mức điều chỉnh: ① Điều chỉnh hạn mức (quản trị viên điều chỉnh thủ công); ② Điều chỉnh thành viên (tiêu thụ khi người thao tác điều chỉnh thủ công số dư thành viên). Trước/Sau hiển thị (Khả dụng / Tổng).',
    tab: {
      opUser: 'Hạn mức tài khoản backend',
      agentAlloc: 'Phân bổ đại lý',
      agentBetween: 'Phân bổ giữa các đại lý',
      memberAlloc: 'Phân bổ người chơi',
      opUserGrant: 'Lịch sử cấp hạn mức đại lý',
    },
    usage: {
      allocate: 'Phân bổ hạn mức',
      recycle: 'Thu hồi hạn mức',
    },
    targetTag: {
      opUser: 'Tài khoản backend',
      agent: 'Đại lý',
      member: 'Người chơi',
    },
    level: {
      platform: 'Nền tảng',
      l1: 'Đại lý cấp 1',
      l2: 'Đại lý cấp 2',
      agent: 'Đại lý',
      superAdmin: 'Quản trị viên cấp cao',
    },
    filter: {
      timeRange: 'Thời gian thay đổi',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      operator: 'Người thao tác',
      operatorPlaceholder: 'Tài khoản người thao tác',
      targetAccount: 'Tài khoản mục tiêu',
      targetPlaceholder: 'Tài khoản backend mục tiêu',
      agentAccount: 'Đại lý mục tiêu',
      agentPlaceholder: 'Tìm tài khoản đại lý',
      memberAccount: 'Người chơi mục tiêu',
      memberPlaceholder: 'Tìm tài khoản người chơi',
      bizType: 'Loại thay đổi',
      bizTypeAll: 'Tất cả loại',
      currency: 'Tiền tệ',
      currencyAll: 'Tất cả tiền tệ',
    },
    bizType: {
      adjustConsume: 'Điều chỉnh thành viên',
      quotaAdjust: 'Điều chỉnh hạn mức',
      opUserRefundFromMember: 'Hoàn lại từ trừ thành viên',
    },
    col: {
      id: 'ID',
      time: 'Thời gian',
      usage: 'Mục đích',
      operator: 'Người thao tác',
      operatorLevel: 'Cấp người thao tác',
      adjustReason: 'Lý do điều chỉnh',
      refundFlag: 'Có thu hồi hạn mức',
      countPayDeposit: 'Tính vào nạp/rút',
      targetAccount: 'Tài khoản mục tiêu',
      targetMember: 'Thành viên mục tiêu',
      currency: 'Tiền tệ',
      bizType: 'Loại',
      changeAvailable: 'Thay đổi khả dụng',
      changeTotal: 'Thay đổi tổng',
      beforeAfterAvailable: 'Trước → Sau (Khả dụng)',
      beforeAfterTotal: 'Trước → Sau (Tổng)',
      grantAmount: 'Số tiền cấp',
      grantAmountSub: 'Khả dụng và tổng cùng tăng',
      afterQuota: 'Sau thay đổi',
      afterQuotaSub: 'Khả dụng / Tổng',
      bizNo: 'Mã giao dịch',
      remark: 'Ghi chú',
    },
  },
  my: {
    menuItem: 'Hạn mức của tôi',
    modal: { title: 'Hạn mức điều chỉnh của tôi' },
    desc: 'Xem hạn mức điều chỉnh và lịch sử thay đổi của tài khoản hiện tại.',
    hero: { onlySelf: 'Tài khoản đăng nhập hiện tại · Chỉ bạn có thể xem', monthConsumed: 'Đã tiêu tháng này: ', account: 'Tài khoản', role: 'Vai trò' },
    currentQuota: { title: 'Hạn mức khả dụng hiện tại', subtitle: 'Dữ liệu thời gian thực · Tự động làm mới' },
    agentAlloc: {
      title: 'Hạn mức phân bổ đại lý',
      subtitle: 'Phân bổ hạn mức cho đại lý (cấp 1/2) · Thời gian thực · tự động làm mới sau khi phân bổ/thu hồi',
      monthUsed: 'Đã dùng tháng này',
    },
    card: { remainLabel: 'Hạn mức còn lại', total: 'Tổng: {val}', monthUsed: 'Tháng này: {val}' },
    filter: {
      time7d: '7 ngày qua', time30d: '30 ngày qua',
      timeMonth: 'Tháng này', timeLastMonth: 'Tháng trước',
      allCurrencies: 'Tất cả tiền tệ', allTypes: 'Tất cả loại',
      consumeType: 'Tiêu thụ điều chỉnh', addType: 'Quản trị tăng', subType: 'Quản trị giảm',
    },
    table: {
      time: 'Thời gian', type: 'Loại', currency: 'Tiền tệ',
      amount: 'Số tiền', afterRemain: 'Còn lại sau', detail: 'Thành viên / Chi tiết',
    },
    total: 'Tổng {count} bản ghi',
  },
  chip: {
    label: 'Hạn mức của tôi',
    unallocated: 'Chưa phân bổ',
    tooltip: 'Nhấp để xem hạn mức điều chỉnh của tôi',
  },
  opuser: {
    agent: {
      column: {
        title: 'Hạn mức ĐL',
        subtitle: 'Marketing · Phân bổ cho đại lý',
        tagNew: 'MỚI',
      },
      btn: { manage: 'Hạn mức ĐL', manageNew: 'MỚI' },
      manage: {
        title: 'Pool phân bổ đại lý',
        banner: 'Pool dành riêng cho phân bổ cho đại lý, độc lập với hạn mức điều chỉnh hội viên bên trái.',
      },
      adjust: { title: 'Điều chỉnh pool phân bổ đại lý', success: 'Thành công', fail: 'Thất bại' },
    },
  },
  agent: {
    btn: { manage: 'Hạn mức' },
    column: { title: 'Hạn mức hiện tại', subtitle: 'Đã dùng / Còn lại' },
    whitelist: {
      bannerTitle: 'Quyền danh sách trắng: ',
      bannerDesc:
        'Đại lý chỉ có thể điều chỉnh hội viên trong danh sách trắng. Mặc định trống = không thể điều chỉnh bất kỳ ai.',
      addBtn: '+ Thêm hội viên',
      downloadTemplate: 'Mẫu',
      batchImportBtn: 'Nhập hàng loạt',
      totalText: 'Tổng {count}',
      search: { placeholder: 'Tìm tài khoản', btn: 'Tìm' },
      stats: {
        whitelistCount: 'Đã cấu hình:',
        directCount: 'Hội viên trực thuộc:',
        coverRate: 'Tỉ lệ:',
        unit: '',
        emptyHint: 'Mặc định trống: không thể điều chỉnh ai cả',
      },
      col: {
        account: 'Tài khoản',
        vipLevel: 'Cấp',
        addTime: 'Ngày thêm',
        addedBy: 'Người thêm',
        action: 'Thao tác',
      },
      add: {
        accountLabel: 'Tài khoản hội viên',
        placeholder: 'Nhập đầy đủ tài khoản hội viên',
        accountRequired: 'Cần nhập tài khoản',
        helpText: 'Hội viên phải tồn tại và thuộc đại lý này',
        success: 'Đã thêm',
        alreadyExists: 'Đã có trong danh sách trắng',
      },
      failReason: {
        MEMBER_NOT_FOUND: 'Không tìm thấy hội viên',
        NOT_DIRECT_MEMBER: 'Hội viên không thuộc đại lý này',
        QUERY_ERROR: 'Lỗi truy vấn',
      },
      remove: {
        btn: 'Xóa',
        confirmTitle: 'Xác nhận xóa',
        confirmContent: 'Xóa {account} khỏi danh sách trắng.',
        success: 'Đã xóa',
      },
      batchImport: {
        title: 'Nhập hàng loạt',
        helpText: 'Tải file CSV / TXT hoặc dán tài khoản (mỗi dòng một, # = ghi chú).',
        uploadBtn: 'Tải lên CSV / TXT',
        placeholder: 'Dán tài khoản ở đây, mỗi dòng một',
        submit: 'Nhập',
        empty: 'Vui lòng nhập ít nhất một tài khoản',
        done: 'Hoàn thành — Thêm {added}, Bỏ qua {skipped}, Thất bại {failed}',
        added: '✓ Thêm',
        skipped: '⚠ Bỏ qua (đã có)',
        failed: '✗ Thất bại',
      },
    },
    manage: {
      title: 'Hạn mức điều chỉnh đại lý',
      accountLabel: 'Tài khoản',
      monthlyConsumedLabel: 'Tháng này',
      monthConsumed: 'Tháng này',
      poolTitle: 'Hạn mức điều chỉnh (Pool chung)',
      poolHint:
        'L1 dùng pool chung cho cả điều chỉnh thủ công với hội viên VÀ phân bổ cho L2. Một pool dùng chung.',
      typeAllocateIn: '↓ Nhận phân bổ',
      typeAllocateOut: '↑ Phân bổ xuống',
      tab: {
        quota: 'Hạn mức',
        memberConfig: 'Cấu hình hội viên',
      },
      memberConfigComingSoon: 'Tab này là chỗ chờ, chưa tích hợp.',
    },
  },
  wallet: {
    operatorRow: {
      operator: 'Người thao tác: ',
      willDeduct: 'Điều chỉnh này sẽ trừ hạn mức "{currency}" của bạn',
      viewDetail: 'Xem chi tiết đầy đủ →',
    },
    preview: {
      after: '→ Còn lại sau: {remain} {currency}',
      insufficient: '→ Thiếu {amount} {currency}',
      viewDetail: 'Xem chi tiết →',
    },
    banner: {
      title: 'Điều chỉnh này sẽ bị chặn',
      desc: 'Không thể gửi: số tiền ({amount}) vượt quá hạn mức còn lại ({remain} {currency}).',
    },
  },
};
